var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeActive28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66675 22.1666V11.6666C4.66675 11.2972 4.74939 10.9472 4.91466 10.6166C5.07994 10.2861 5.30841 10.0139 5.60008 9.79998L12.6001 4.54998C13.0084 4.23887 13.4751 4.08331 14.0001 4.08331C14.5251 4.08331 14.9917 4.23887 15.4001 4.54998L22.4001 9.79998C22.6917 10.0139 22.9202 10.2861 23.0855 10.6166C23.2508 10.9472 23.3334 11.2972 23.3334 11.6666V22.1666C23.3334 22.8083 23.1049 23.3576 22.648 23.8146C22.1911 24.2715 21.6417 24.5 21.0001 24.5H17.5001C17.1695 24.5 16.8924 24.3882 16.6688 24.1646C16.4452 23.941 16.3334 23.6639 16.3334 23.3333V17.5C16.3334 17.1694 16.2216 16.8923 15.998 16.6687C15.7744 16.4451 15.4973 16.3333 15.1667 16.3333H12.8334C12.5029 16.3333 12.2258 16.4451 12.0022 16.6687C11.7786 16.8923 11.6667 17.1694 11.6667 17.5V23.3333C11.6667 23.6639 11.5549 23.941 11.3313 24.1646C11.1077 24.3882 10.8306 24.5 10.5001 24.5H7.00008C6.35841 24.5 5.80911 24.2715 5.35216 23.8146C4.89522 23.3576 4.66675 22.8083 4.66675 22.1666Z",
    fill: "#1C2227"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeActive28);
export default __webpack_public_path__ + "static/media/home_active_28.98be917f0afa1c8fa93e08d97178ff60.svg";
export { ForwardRef as ReactComponent };